import script from "./VariantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantCard.vue?vue&type=script&setup=true&lang=js"

import "./VariantCard.vue?vue&type=style&index=0&id=57025c18&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57025c18"]])

export default __exports__